import { useEffect, useRef, useState } from "react";
import { ImageOff } from "lucide-react";

export function LazyImage({ src, alt, className = "", onClick, testid, iconSize = 32 }) {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    setLoaded(false); setError(false);
  }, [src]);

  useEffect(() => {
    const el = ref.current;
    if (!el || visible) return;
    if (!("IntersectionObserver" in window)) { setVisible(true); return; }
    const io = new IntersectionObserver((entries) => {
      if (entries.some((e) => e.isIntersecting)) { setVisible(true); io.disconnect(); }
    }, { rootMargin: "300px" });
    io.observe(el);
    return () => io.disconnect();
  }, [visible]);

  return (
    <div ref={ref} className={`relative w-full h-full overflow-hidden ${className}`} data-testid={testid ? `${testid}-wrap` : undefined}>
      {!loaded && !error && <div className="absolute inset-0 skeleton-shimmer" data-testid={testid ? `${testid}-skeleton` : undefined} />}
      {error && <div className="absolute inset-0 flex items-center justify-center text-muted-foreground bg-muted"><ImageOff size={iconSize} /></div>}
      {visible && !error && (
        <img src={src} alt={alt} onClick={onClick} data-testid={testid} decoding="async"
          onLoad={() => setLoaded(true)} onError={() => setError(true)}
          className={`w-full h-full object-cover transition-opacity duration-500 ${loaded ? "opacity-100" : "opacity-0"} ${onClick ? "cursor-zoom-in" : ""}`} />
      )}
    </div>
  );
}
